import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";

type ControlledInputPropType = {
    name: string, control: any, label: string, errors: any, size?: number, width?: string, disabled?: boolean, rows?: number
}
export const ControlledTextArea = ({ name, control, label, errors, size = 4, width, disabled, rows }: ControlledInputPropType) => {

    return (

        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value } }) => (
                <TextField
                    disabled={disabled}
                    multiline
                    rows={rows ? rows : 3}
                    sx={{ width: width ? width : "100%", padding: '0 !important' }}
                    onChange={onChange}
                    value={value ?? ''}
                    label={label}
                    variant="outlined"
                    error={errors[name] && Boolean(errors[name].message)}
                    helperText={errors[name] ? `${errors[name].message}` : ""}
                />
            )}
        />

    );
}
